import * as React from "react";
import { createComponent } from "@lit/react";
import Component from "../../components/Divider/sgds-divider";
import { register } from "../../utils/ce-registry";

register("sgds-divider", Component);

export default createComponent({
  react: React,
  tagName: "sgds-divider",
  elementClass: Component,
  events: {}
});
